module.exports = __webpack_public_path__ + "img/icon_ort_marker.49cb0ae7.svg";